import LokasiKontak from "./Kontak/LokasiKontak";
import LokasiJadwal from "./Jadwal/LokasiJadwal";
import LokasiInfo from "./Info/LokasiInfo";
import LokasiAlamat from "./Alamat/LokasiAlamat";

export default function LokasiForm({
	formDataInfo,
	setFormDataInfo,
	formDataJadwal,
	setFormDataJadwal,
	formDataAlamat,
	setFormDataAlamat,
	formDataKontak,
	setFormDataKontak,
}) {
	return (
		<>
			<LokasiInfo
				formDataInfo={formDataInfo}
				setFormDataInfo={setFormDataInfo}
			/>
			<LokasiJadwal
				formDataJadwal={formDataJadwal}
				setFormDataJadwal={setFormDataJadwal}
			/>
			<LokasiAlamat
				formDataAlamat={formDataAlamat}
				setFormDataAlamat={setFormDataAlamat}
			/>
			<LokasiKontak
				formDataKontak={formDataKontak}
				setFormDataKontak={setFormDataKontak}
			/>
		</>
	);
}
